/* eslint-disable sonarjs/no-duplicate-string */
import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import type { BusinessTemplatesAPIResponse } from 'reactApp/modules/businessTemplates/businessTemplates.types';

export class BusinessTemplatesAPICall extends APICallV4<BusinessTemplatesAPIResponse> {
    _method = 'private/templates';
    _type: Method = 'get';
}
